

import React, { useState, useEffect } from "react";
import InputWithIcon from "../../components/ui/InputWithIcon";
import MessageBox from "../../components/ui/MessageBox";
import Button from "../../components/ui/Button";
import { useAuth } from "../../context/AuthContext";
import api from "../../api/api";
import { getAllowedUsers } from "../../api/configHelper";

const LoginPage = () => {
  const [username, setUsername] = useState("admin");
  const [password, setPassword] = useState("admin");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [company, setCompany] = useState(null);
  const { login } = useAuth();

  useEffect(() => {
    const fetchCompanyDetails = async () => {
      try {
        const data = await api.CompanyDetails(username);
        if (data?.Table?.length > 0) {
          setCompany(data.Table[0]);
        }
      } catch (err) {
        console.error("Error fetching company details:", err);
      }
    };
    fetchCompanyDetails();
  }, [username]);

  const handleLogin = async (e) => {
  e.preventDefault();
  setError("");
  setLoading(true);

  try {
    const data = await api.checkLogin(username, password);

    const rootKey = Object.keys(data)[0]; 
    const table = data[rootKey]?.Table;

    if (table?.length > 0) {
      const allowedUsers = await getAllowedUsers();
      const allowedList = allowedUsers === "*" ? null : allowedUsers.split(",").map(u => u.trim());

      if (allowedList && !allowedList.includes(username)) {
        setError("You are not allowed to login.");
        setLoading(false);
        return;
      }

      const userData = {
        UsrId: table[0].Usrid,
        UsrName: table[0].UsrName,
        ComName: table[0].comname,
      };
      login(userData); 
    } else {
      setError("Login failed. Please check your credentials.");
    }
  } catch (err) {
    console.error(err);
    setError("An error occurred during login.");
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="bg-white shadow-xl rounded-2xl p-10 w-full max-w-md">
        {/* Company Name */}
        <h1 className="text-3xl font-bold text-center mb-2 text-gray-800">
          {company?.Comname || "Loading..."}
        </h1>

        {/* Company Address */}
        {company && (
          <p className="text-sm text-center text-gray-500 mb-6">
            {[company.Address1, company.Address2, company.City, company.State, company.Pincode]
              .filter(Boolean)
              .join(", ")}
          </p>
        )}

        <h2 className="text-2xl font-semibold text-center mb-6">Login</h2>
        <form onSubmit={handleLogin}>
          <InputWithIcon
            label="Username"
            id="username"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-gray-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                />
              </svg>
            }
          />
          <InputWithIcon
            label="Password"
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 text-gray-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
                />
              </svg>
            }
          />
          {error && <MessageBox message={error} />}
          <div className="flex items-center justify-center mt-6">
            <Button type="submit" disabled={loading} className="w-full">
              {loading ? "Logging in..." : "Login"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
